// Woocommerce look up for table listing archive products
jQuery(document).ready(function ($) {


    function showLoader() {
        $('.js-ajax-loader-table').removeClass('hidden');
    }

    function hideLoader() {
        $('.js-ajax-loader-table').addClass('hidden');
    }

    function lookupTableProducts() {
        var year = $('.js-table-year').val(); // Get the product ID dynamically
        var id = $('.js-table-year').data('id');
        var page = $('.js-table-page').val();

        showLoader();

        $.ajax({
            url: woocommerce_params.ajax_url,
            type: 'POST',
            data: {
                'action': 'get_table_products',
                'category_id': id,
                'year': year,
                'page': page
            },
            success: function (response) {
                hideLoader();

                const tableOutput = JSON.parse(response.table);
                const paginationOutput = JSON.parse(response.pagination);

                $('.js-product-single-table tbody').html(tableOutput);
                $('.js-table-listing-pagination').html(paginationOutput);
            },
        });
    }

    $('.js-table-year').on('change', function () {
        $('.js-table-page').val(1);
        lookupTableProducts();
    });

    $('.js-table-reset').on("click", function () {
        $('.js-table-page').val(1);
        $('.js-table-year').val("");
        lookupTableProducts();
    });

    $(document).on('click', '.js-table-listing-pagination a', function (e) {
        e.preventDefault();
        const link = e.target.href ?? '';
        const pages = link.split("page/");
        const pagesAjax = link.split("paged=");

        if (pages && pages.length > 1 && pages[1]) {
            $('.js-table-page').val(pages[1]);
        } else if (pagesAjax && pagesAjax.length > 1 && pagesAjax[1]) {
            $('.js-table-page').val(pagesAjax[1]);
        } else {
            $('.js-table-page').val(1);
        }

        lookupTableProducts();
    });
});
